import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { Button } from "@/components/ui/button";

const links = [
  { label: "Product", href: "#product" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "For Organisers", href: "#organisers" },
  { label: "Reports", href: "#reports" },
  { label: "Pricing", href: "#pricing" },
];

export default function LandingNav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-border backdrop-blur-xl bg-background/70">
      <nav className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo markClass="h-8 w-8" textClass="text-lg" />

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-2">
          <Button asChild variant="ghost" className="rounded-full text-sm">
            <Link to="/login" data-testid="nav-sign-in">Sign In</Link>
          </Button>
          <Button asChild className="rounded-full bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
            <Link to="/register" data-testid="nav-get-started">Get Started</Link>
          </Button>
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-border bg-background px-5 py-4 space-y-3">
          {links.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="block text-sm font-medium text-muted-foreground">
              {l.label}
            </a>
          ))}
          <div className="flex gap-2 pt-2">
            <Button asChild variant="outline" className="flex-1 rounded-full">
              <Link to="/login">Sign In</Link>
            </Button>
            <Button asChild className="flex-1 rounded-full">
              <Link to="/register">Get Started</Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
